import { useCallback } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_RESET_RECOVERY_CODES } from '@/app/module/user/definitions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useResetRecoveryCodes = () => {
  const dispatch = useAppDispatch()
  const [mutate, res] = esApi.useNewUserRecoveryCodesMutation()

  const resetCodes = useCallback(async () => {
    try {
      return await mutate().unwrap()
    } catch (error) {
      dispatch(
        createNotification({
          'reset-recovery-codes': {
            type: 'error',
            message: getErrorMessage(error, ERROR_RESET_RECOVERY_CODES),
          },
        }),
      )
      return undefined
    }
  }, [dispatch, mutate])

  return [resetCodes, res] as const
}
